if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false,
    });

    $('.slick-slider').slick({
        accessibility: true,
        arrows: true,
        fade: true,
        autoplay: false,
        adaptiveHeight: true,
        autoplaySpeed: 4000,
        nextArrow: ".arrows-slider-next",
        prevArrow: ".arrows-slider-prev"

    });
    $('.whats-slider').slick({
        accessibility: false,
        arrows: true,
        fade: true,
        autoplay: false,
        adaptiveHeight: true,
        autoplaySpeed: 4000,
        nextArrow: ".whats-next",
        prevArrow: ".whats-prev"

    });
     $('.slider__badges_gallery').slick({
        slidesToShow:5,
        slidesToScroll:5,
        dots: true,
        arrows: false,
        customPaging: function (slider, i) {
            let number = (i + 1).toString().padStart(2, '0');
            return `
                <button type="button">
                    <span class="dot-number">${number}</span>
                </button>
            `;
        }

    });

    // Slick Slider with current slide number
    $('.js-slick_showIndex').each((i, el) => {
        let currentIndex = '01';

        $(el).on('init', (e, s) => {
            if (s.options.dots) {
                $(s.options.appendDots).append(`<span class="slick-current_index">${currentIndex}</span>`);
            } else if (s.options.arrows) {
                $(s.options.appendArrows).prepend(`<span class="slick-current_index">${currentIndex}</span>`);
            }
        });

        $(el).on('beforeChange', (e, s, c, n) => {
            currentIndex = (`0${(n+1)}`).slice(-2);
            if (s.options.dots) {
                $('.slick-current_index', s.options.appendDots).text(currentIndex);
            } else if (s.options.arrows) {
                $('.slick-current_index', s.options.appendArrows).text(currentIndex);
            }
        });

        $(el).slick();
    });

    //Hover funcion
    $('.card').hover(function (e) {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
        var href = $(this).attr('data-target');
        $(href).addClass('active');
        $(href).siblings().removeClass('active');

    });
})();


// shortcode tabs
const tabs = document.querySelectorAll(".tab-seccion__nav")[0];
const tabButton = document.querySelectorAll(".tab-seccion__item");
const contents = document.querySelectorAll(".tab-seccion__tab");

if (tabs !== undefined) {
    tabs.addEventListener('click', item)
}

function item(e) {
    e.preventDefault();
    const id = e.target.dataset.id;
    if (id) {
        tabButton.forEach(btn => {
            btn.classList.remove("active");
        });
        e.target.classList.add("active");

        contents.forEach(content => {
            content.classList.remove("active");
        });
        const element = document.getElementById(id);
        element.classList.add("active");
    }
}
//filter function
$('.portafolio__item').addClass('active');

//for desktop
$("#portafolio__filter li").click(function () {
    const thisTag = $(this).attr('data-tag');
    $(".gridder-close").click();
    $('.portafolio__item').removeClass('active');
    $('.portafolio__item.' + thisTag).addClass('active');
    $('.portafolio__filter--item').removeClass('active');
    $('.portafolio__filter--item.' + thisTag).addClass('active');
});
// //for mobile
// $("#portafolio__filter").change(function () {
//     const this_tag = $(this).val();
//     $(".gridder-close").click();
//     $('.portafolio__item').removeClass('active');
//     $('.portafolio__item.' + this_tag).addClass('active');
//     $('.portafolio__filter--item.' + thisTag).addClass('active');
// });

// Call Gridder
$('.gridder').gridderExpander({
    scroll: true,
    scrollTo: "panel", // panel or listitem
    animationSpeed: 400,
    animationEasing: "easeInOutExpo",
    showNav: true, // Show Navigation
    nextText: "Next", // Next button text
    prevText: "Previous", // Previous button text
    closeText: "Close", // Close button text
    onStart: function () {
        //Gridder Inititialized
    },
    onContent: function () {
        //Gridder Content Loaded
    },
    onClosed: function () {
        //Gridder Closed
    }
});

//Trigger Click filter portafolio
if (document.body.classList.contains('our-hotel-management-portfolio')) {
    var hashPopup = window.location.hash;
    var finalHash = hashPopup.replace('#', '');
    console.log(finalHash)
    document.getElementById(finalHash).click();
}